// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { success } from 'react-notification-system-redux'
import { loadingToggler } from 'redux/modules/loading'
import handlePathWarningsCheck from './handlePathWarningsCheck'
import { handleCallsignCascadeMatches } from 'redux/helpers'

// once a path details has been successfully saved,
// verify that the new path data does not produce warnings now.

const handleSuccessfulSave = (res, callsignCascadeTriggerData, openContextModal, handleSuccessfulSubmitCallback) => dispatch => (
  dispatch(loadingToggler(
    async () => {
      const {
        entity: pathData,
        message,
      } = res

      const {
        pathId,
        segments,
      } = pathData

      // we only await these because we want the loading icon to remain while this is happening. we don't
      // actually need to await the results or for values to be updated in DB here.
      await Promise.all([
        dispatch(handlePathWarningsCheck(pathId)),
        dispatch(handleCallsignCascadeMatches(callsignCascadeTriggerData, openContextModal, handleSuccessfulSubmitCallback)),
      ])

      // since we can't rely upon path name, display the site 1 and 2 names
      // to tell the user that the path was saved/updated.
      const lastSegIndex = segments.length - 1
      const site1Name = segments[0].segmentEnds[0].siteName
      const site2Name = segments[lastSegIndex].segmentEnds[1].siteName

      const idRoot = 'notification-successful-path-save'

      // update UI to show user success message
      return dispatch(success({
        autoDismiss: 5,
        message: (
          <span id={`${idRoot}-message`}>
            {`You have successfully saved ${site1Name} - ${site2Name}`}
          </span>
        ),
        title: (
          <span id={`${idRoot}-title`}>
            {message}
          </span>
        ),
        uid: idRoot,
      }))
    })
  )
)

export default handleSuccessfulSave
